import Honeybadger from '@honeybadger-io/js'

export function configureHoneybadger() {
  const environmentName = environment()
  Honeybadger.configure({
    apiKey: import.meta.env.HONEYBADGER_API_KEY,
    environment: environmentName,
    reportData: !import.meta.env.DEV && environmentName === 'production',
    revision: import.meta.env.HONEYBADGER_REVISION,
  })
}

function environment() {
  const { origin } = window.location

  if (origin.endsWith('//edit-neocrm.justrelate.com')) return 'production'
  else if (origin.endsWith('//edit.neodxp.com')) return 'production'
  else if (origin.endsWith('.justrelate.com')) return 'beta'
  else if (origin.endsWith('.pages.dev')) return 'preview'
  else return 'development'
}
